import FlightRoute from "./FlightRoute";

export default FlightRoute;